import { createApiAction } from '@saucelabs/sl-util-redux';

import { getFilterParamsAdapter, getTimeFilterParams, getPaginationParams } from './../../api-adapter';
import * as api from './api';
import * as constants from './types';
import { LOAD_INIT_DATA } from './../general/types';
import { getFilters, clearAndGetFilters } from './../filters/operations';
import { getOrganization } from './../general/operations';
import { TESTS_PAGE_FILTER_FAILING, TESTS_PAGE_FILTER_PASSING } from './constants';

// method to get date interval for api call (minute / hour / day)
const getInterval = (timeSpan) => {
  if (timeSpan > 60 * 60 * 24) {
    return '1d';
  }

  if (timeSpan <= 60 * 60) {
    return '1m';
  }

  return '1h';
};

export const getTrends = createApiAction(
  constants.GET_TEST_TRENDS,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const timeParam = getTimeFilterParams(analytics.filters.get('selectedDateFilter'));

    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
      interval: getInterval(timeParam.end - timeParam.start),
    };
    return api.getTrends(params);
  },
);

export const getPastTrends = createApiAction(
  constants.GET_PAST_TRENDS,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const timeParam = getTimeFilterParams(analytics.filters.get('selectedDateFilter'));
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(
        analytics.filters.get('selectedDateFilter'),
        Date.now() - (analytics.filters.getIn(['selectedDateFilter', 'value']) * 1000),
      ),
      interval: getInterval(timeParam.end - timeParam.start),
      ...payload,
    };

    return api.getTrends(params);
  },
);

export const getAggregatedTestErrors = createApiAction(
  constants.GET_AGGREGATED_TEST_ERRORS,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
      ...payload,
    };
    return api.getAggregatedTestErrors(params);
  },
);

export const getTestHealth = createApiAction(
  constants.GET_TEST_HEALTH,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
    };
    return api.getTestHealth(params);
  },
);

export const getPastHealth = createApiAction(
  constants.GET_PAST_HEALTH,
  (payload, meta, dispatch, getState) => {
    const { apps: { analytics } } = getState();
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(
        analytics.filters.get('selectedDateFilter'),
        Date.now() - (analytics.filters.getIn(['selectedDateFilter', 'value']) * 1000),
      ),
    };
    return api.getTestHealth(params);
  },
);

export const loadInitOverview = createApiAction(
  LOAD_INIT_DATA,
  (payload, meta, dispatch) => Promise.all([
    dispatch(getTrends()),
    dispatch(getPastTrends()),
    dispatch(getFilters()),
    dispatch(getOrganization()),
  ]),
);

const sortDescending = 'desc';
const sortAscending = 'desc';
const filterToStatus = {
  [TESTS_PAGE_FILTER_FAILING]: 'failed',
  [TESTS_PAGE_FILTER_PASSING]: 'passed',
};

export const loadAggregatedTestNames = createApiAction(
  constants.GET_AGGREGATED_TEST_NAMES,
  (payload = {}, meta, dispatch, getState) => {
    const direction = payload.sortDescending ? sortDescending : sortAscending;
    const { apps: { analytics } } = getState();
    const params = {
      ...getFilterParamsAdapter(analytics.filters.get('filters')),
      ...getTimeFilterParams(analytics.filters.get('selectedDateFilter')),
      ...getPaginationParams(analytics.testList.get('pagination')),
      status: filterToStatus[analytics.testOverview.get('testCaseQuery')] || null,
      order: direction,
    };
    return api.getAggregatedTestNames(params);
  },
);

export const updateData = () => (dispatch) => Promise.all([
  dispatch(getFilters()),
  dispatch(getTrends()),
  dispatch(getPastTrends()),
  dispatch(getAggregatedTestErrors()),
  dispatch(loadAggregatedTestNames()),
  dispatch(getTestHealth()),
  dispatch(getPastHealth()),
]);

export const clearFilters = (location) => (dispatch) => Promise.all([
  dispatch(clearAndGetFilters(null, { location })),
  dispatch(updateData()),
]);
